import React, { useState, useEffect } from 'react'
import { Modal, Button, Spinner, Alert } from 'react-bootstrap'

interface DeleteUserModalProps {
    show: boolean
    onHide: () => void
    onSubmit: () => Promise<void>
    username?: string
}

const DeleteUserModal: React.FC<DeleteUserModalProps> = ({ show, onHide, onSubmit, username }) => {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)

    const handleSubmit = async () => {
        setLoading(true)
        setError(null)

        try {
            await onSubmit()
            setLoading(false)
            handleClose()
        } catch (err) {
            setLoading(false)
            setError('Failed to delete user. Please try again.')
        }
    }

    const handleClose = () => {
        setError(null)
        onHide()
    }

    useEffect(() => {
        if (!show) {
            setError(null)
        }
    }, [show])

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Delete User</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {error && <Alert variant="danger">{error}</Alert>}
                <p>
                    Are you sure you want to permanently delete{' '}
                    <strong>{username}</strong>?
                </p>
                <p className="text-danger mb-0">
                    This action cannot be undone.
                </p>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose} disabled={loading}>
                    Cancel
                </Button>
                <Button variant="danger" onClick={handleSubmit} disabled={loading}>
                    {loading ? (
                        <>
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />{' '}
                            Deleting...
                        </>
                    ) : (
                        'Delete User'
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default DeleteUserModal
